import {createActions, createReducer} from 'reduxsauce';
import {
  REQUEST_NOT_STARTED,
  REQUEST_PENDING,
  REQUEST_REJECTED,
  REQUEST_RESOLVED,
} from 'constants/request';

export const {Types: OffersTypes, Creators: OffersActions} = createActions({
  listOffers: ['params'],
  listOffersSuccess: ['payload'],
  offersRequestFailure: ['error'],
});

const INITIAL_STATE = {
  listOffers: {
    items: [],
    meta: {
      totalPages: 0,
      itemsPerPage: 20,
      currentPage: 1,
    },
  },
  error: null,
  offersRequests: {
    [OffersTypes.LIST_OFFERS]: REQUEST_NOT_STARTED,
  },
};

const listOffers = (state) => ({
  ...state,
  offersRequests: {
    ...INITIAL_STATE.offersRequests,
    [OffersTypes.LIST_OFFERS]: REQUEST_PENDING,
  },
});
const listOffersSuccess = (state, {payload}) => ({
  ...state,
  listOffers: payload,
  offersRequests: {
    ...INITIAL_STATE.offersRequests,
    [OffersTypes.LIST_OFFERS]: REQUEST_RESOLVED,
  },
});
const offersRequestFailure = (state, {error: {response}}) => ({
  ...state,
  error: response,
  offersRequests: {
    ...state.offersRequests,
    [OffersTypes.LIST_OFFERS]: REQUEST_REJECTED,
    [OffersTypes.RANKING]: REQUEST_REJECTED,
  },
});

export default createReducer(INITIAL_STATE, {
  [OffersTypes.LIST_OFFERS]: listOffers,
  [OffersTypes.LIST_OFFERS_SUCCESS]: listOffersSuccess,
  [OffersTypes.OFFERS_REQUEST_FAILURE]: offersRequestFailure,
});
